import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export const OverviewContent = () => {


    const [linkCopied, setLinkCopied] = useState(false);
    const navigate = useNavigate();
    // setRefLink(localStorage.getItem("user").referralLink);
    // console.log(localStorage.getItem("user"))
    // console.log(referralLink.referralLink)

    const [userData, setUserData] = useState({
        link: "",
        name: "",
        balance: 0,
        totalEarnings: 0,
        referred: {
            level1: 0,
            level2: 0,
            level3: 0
        },
        gain: 0,
        gainTaches: 0,
        pendingWithdrawals: 0
    });


    // console.log()d

    useEffect(() => {
        const rawUser = localStorage.getItem("user");
        if (!rawUser) return;

        const user = JSON.parse(rawUser);

        if (user?.referralLink) {

            setUserData(prev => ({
                ...prev,
                ...user,
                link: user.referralLink
            }));
        }
    }, []);


    // const apiUrl = process.env.REACT_APP_CAPITALYA_API_URL;

    const handleCopyLink = () => {
        navigator.clipboard
            .writeText(userData.link)
            .then(() => {
                setLinkCopied(true);
                setTimeout(() => setLinkCopied(false), 2000)
            })
            .catch((err) => console.log("Erreur de copie du lien de parrainage", err))
    }

    // useEffect(() => {
    //     const response = fetch(`${apiUrl}/`,{
    //         headers:{
    //             Authorization: `Bearer ${token}`
    //         }
    //     })
    // }, [])

    return (
        <div className="space-y-4 pb-20"> {/* Padding bottom pour navigation mobile */}
            {/* Stats Cards - Stack vertical sur mobile */}
            <div className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-6">

                <div className="bg-white rounded-lg shadow-md p-3 md:p-6">
                    <div className="text-center md:flex md:items-start md:text-left">
                        <div className="text-2xl md:text-3xl mb-1 md:mb-0 md:mr-4">📈</div>
                        <div>
                            <p className="text-xs md:text-sm font-medium text-gray-600">Total des gains</p>
                            <p className="text-sm md:text-2xl font-bold text-blue-600">
                                {(userData.gain + userData.gainTaches).toLocaleString()}F
                            </p>
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-lg shadow-md p-3 md:p-6">
                    <div className="text-center md:flex md:items-start md:text-left">
                        <div className="text-2xl md:text-3xl mb-1 md:mb-0 md:mr-4">💳</div>
                        <div>
                            <p className="text-xs md:text-sm font-medium text-gray-600">Solde de parrainage</p>
                            <p className="text-sm md:text-2xl font-bold text-green-600">
                                {userData.gain.toLocaleString()}F
                            </p>
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-lg shadow-md p-3 md:p-6">
                    <div className="text-center md:flex md:items-start md:text-left">
                        <div className="text-2xl md:text-3xl mb-1 md:mb-0 md:mr-4">⏳</div>
                        <div>
                            <p className="text-xs md:text-sm font-medium text-gray-600">Solde mini-jeux</p>
                            <p className="text-sm md:text-2xl font-bold text-orange-600">
                                {userData.gainTaches.toLocaleString()}F
                            </p>
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-lg shadow-md p-3 md:p-6">
                    <div className="text-center md:flex md:items-start md:text-left">
                        <div className="text-2xl md:text-3xl mb-1 md:mb-0 md:mr-4">👥</div>
                        <div>
                            <p className="text-xs md:text-sm font-medium text-gray-600">Parrainés</p>
                            <p className="text-sm md:text-2xl font-bold text-purple-600">
                                {userData.referred.length}<span> filleul(s)</span>
                            </p>

                        </div>
                    </div>
                </div>

            </div>

            {/* Section Lien d'invitation - Optimisée mobile */}
            <div className="bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg shadow-md p-4 md:p-6 text-white">
                <h3 className="text-lg md:text-xl font-bold mb-3 md:mb-4">🔗 Votre Lien de Parrainages</h3>

                {/* Version mobile - Stack vertical */}
                <div className="space-y-3 md:hidden">
                    <input
                        type="text"
                        value={userData.link}
                        readOnly
                        className="w-full px-3 py-2 bg-white/20 rounded border-0 text-white text-sm"
                    />
                    <div className="flex space-x-2">
                        <button onClick={handleCopyLink} className="flex-1 bg-white/20 hover:bg-white/30 px-3 py-2 rounded transition-colors text-sm">
                            📋 {linkCopied ? "Lien Copié" : "Copier"}
                        </button>
                        <button className="flex-1 bg-white/20 hover:bg-white/30 px-3 py-2 rounded transition-colors text-sm">
                            📱 Partager
                        </button>
                    </div>
                </div>

                {/* Version desktop - Horizontal */}
                <div className="hidden md:flex items-center space-x-4">
                    <input
                        type="text"
                        value={userData.link}
                        readOnly
                        className="flex-1 px-3 py-2 bg-white/20 rounded border-0 text-white placeholder-white/70"
                    />
                    <button onClick={handleCopyLink} className="bg-white/20 hover:bg-white/30 px-4 py-2 rounded transition-colors">
                        📋 {linkCopied ? "Lien Copié" : "Copier"}
                    </button>
                    <button className="bg-white/20 hover:bg-white/30 px-4 py-2 rounded transition-colors">
                        📱 Partager
                    </button>
                </div>

                <p className="mt-2 text-xs md:text-sm opacity-90">
                    Gagnez 1400F par inscription activée !
                </p>
            </div>

            {/* Actions rapides - Mobile */}
            <div className="grid grid-cols-2 gap-3 md:hidden">
                <button
                    onClick={() => navigate('/dashboard/referrals')}
                    className="bg-white rounded-lg shadow-md p-4 text-center hover:bg-gray-50 transition-colors"
                >
                    <div className="text-2xl mb-1">👥</div>
                    <div className="text-sm font-medium text-gray-800">Voir Parrainages</div>
                </button>
                <button
                    onClick={() => navigate('/dashboard/withdrawals')}
                    className="bg-white rounded-lg shadow-md p-4 text-center hover:bg-gray-50 transition-colors"
                >
                    <div className="text-2xl mb-1">🏦</div>
                    <div className="text-sm font-medium text-gray-800">Retirer</div>
                </button>
            </div>
        </div>);
}